export const DOCUMENTS_UPLOAD_LARGE_FILE_MAX_SIZE = 36700160; // 35MB
export const DOCUMENTS_UPLOAD_FILE_MAX_SIZE = 7340032; // 7MB
export const DOCUMENTS_UPLOAD_IMAGE_MAX_SIZE = 5242880; // 5MB
export const DOCUMENTS_UPLOAD_XLSM_MAX_SIZE = 5242880; // 5MB
